/*
 * Ryan O'Dowd
 * 2025-05-18
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
import React from 'react';
import {
  View,
} from 'react-native';

const LinearGradient = (props: LinearGradientProps) => {
  return <View style={props.style} />;
};

class LinearGradientProps {
  style?: any;

  linearGradientProps?: any = {}; // @TODO: this isn't used, but it is in native, so this prevents ts warnings
};

export default LinearGradient;
